import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Pagination } from '../Pagination';

const BottomBarContainer = styled.div`
  margin: var(--size-dynamic0040) var(--size-grid002) var(--size-grid001);
  max-width: 1750px;
  display: flex;
  justify-content: end;
`;

export default () => {

    return (
        <BottomBarContainer>
            <Pagination />
        </BottomBarContainer>
    );
}